<template>
    <div>
        <md-dialog-alert
            :md-active.sync="dialog.status"
            :md-content="dialog.content" 
            :md-confirm-text="dialog.confirmText" 
            @md-closed="dialog.content = ''"/>
        <md-table :value="filteredItems">
            <md-table-row slot="md-table-row" slot-scope="{ item }" :id="item.id">
                <div class="md-layout">
                    <div class="comment-box _commentCard">
                        <div class="_commentCard__header">
                            <md-avatar class="_commentCard__avatar">
                                <img src="/img/default-avatar.png" alt="Avatar">
                            </md-avatar>
                            <div class="_commentCard__title">
                                <span class="_commentCard__author" v-if="item.owner">{{ item.user ? item.user.given_name + ' ' + item.user.family_name : '' }}</span> 
                                <span class="_commentCard__time">
                                    <md-icon v-if="item.internal">lock</md-icon>
                                    <md-icon>schedule</md-icon>
                                    {{ timediff(item.updatedAt) }}
                                </span>
                            </div>
                        </div>
                        <div class="_commentCard__body">
                            <div v-if="uniqueCommentId !== item.id" slot="content" class="bold-400 text-editor-content" v-html="item.comment" v-linkified></div>
                            <div class="md-layout-item md-layout-item-attachment md-layout-item-padding" v-if="item.attachment">
                                <template v-for="(file, index) in item.attachment" >
                                    <div v-if="($Session && $Session.isInternalGroupMember) || !file.internal" class="md-layout md-gutter md-alignment-center" v-bind:key="index">
                                        <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100" >
                                            <div v-show="file.name" class="attchment-card">
                                                <div class="attchment-container">{{ file.description }} 
                                                    <div><a :href="file.s3Path" target="_blank">{{ file.name }}</a></div>
                                                    <!-- <div>{{ file.type }}</div> -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                            <template v-if="uniqueCommentId === item.id">
                                <md-checkbox v-show="$Session && $Session.isInternalGroupMember" v-model="internal">Internal</md-checkbox>
                                <md-field class="_tinyMceField">
                                    <TinyMceEditor :content="updateCommentModel" :mentionArr="userListItems" v-model="updateCommentModel" />
                                    <div class="dynamicList-loading-spinner" v-show="promisePending">
                                        <md-progress-spinner :md-diameter="30" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
                                    </div>
                                </md-field>
                                <md-card-actions md-alignment="left">
                                    <md-button class="md-simple md-just-icon _attachFileBtn">
                                        <i class="material-icons" v-on:click="onUpload()">attachment</i>
                                    </md-button>
                                    <span v-if="attachmentData == null">Browse or attach file here</span>
                                    <!-- <div class="md-layout-item" v-if="attachmentData">
                                        <div class="md-layout md-gutter md-alignment-center">
                                        <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100" >
                                            <div v-show="attachmentData.file.name" class="attchment-card">
                                            <div class="attchment-container">{{ attachmentData.file.name }} 
                                                <div>{{ attachmentData.description }}</div> ({{ attachmentData.file.size | kb }} kb)
                                                <div>{{ attachmentData.type }}</div>
                                                <button type="button" class="attachment-button" title="Remove" @click="removeFile()" >x</button>
                                            </div>
                                            <md-checkbox 
                                                class="attachment-area__checkbox" 
                                                v-show="$Session && $Session.isInternalGroupMember"
                                                v-model="attachmentData.internal"
                                            >Internal</md-checkbox>
                                            </div>
                                        </div>
                                        </div>
                                    </div> -->
                                </md-card-actions>
                            </template>
                        </div>
                        <div class="_commentCard__footer">
                            <div class="link">
                                <div title="Edit" class="edit" v-if="uniqueCommentId !== item.id" @click="editComment(item)">
                                    <!-- Edit -->
                                    <md-icon>edit</md-icon>
                                </div>
                                <div title="Delete" class="delete" v-if="$Session.isAdminGroupMember && uniqueCommentId !== item.id" @click="deleteCommentAlert(item)">
                                    <!-- Delete -->
                                    <md-icon>delete</md-icon>
                                </div>
                                <div title="Save" class="edit" v-if="uniqueCommentId === item.id" @click="updateComment(item)">
                                    <!-- Update -->
                                    <md-icon>save</md-icon>
                                </div>
                                <div title="Close" class="edit" v-if="uniqueCommentId === item.id" @click="clearComment()">
                                    <!-- Cancel -->
                                    <md-icon>close</md-icon>
                                </div>
                            </div>
                        </div>
                    </div>    
                </div>
            </md-table-row>
        </md-table>
        <!-- Upload Dialog -->
        <md-dialog :md-active.sync="isUploadDialogOpen" class="_attachmentsDialog">
          <md-dialog-title>Attachment</md-dialog-title>
          <md-dialog-content>
            <CommentAttachmentsForm
              :docTypes="docTypes"
              :model="attachmentData"
              @success="onUploadSuccess"
            />
          </md-dialog-content>
        </md-dialog>
        <md-snackbar md-position="center" :md-active.sync="isSnackbarOpen" md-persistent>
          <span>{{ snackbarMsg }}</span>
        </md-snackbar>
    </div>        
</template>

<script>
import _ from "lodash";
import Swal from "sweetalert2";
import {API, graphqlOperation } from 'aws-amplify';
import * as mutations from '@/graphql/mutations';
import * as queries from "@/graphql/queries";
import * as subscriptions from "@/graphql/subscriptions"
import * as queries_custom from "@/graphql/queries_custom";
import aws_exports from "../../aws-exports";
import CommentAttachmentsForm from '@/components/DynamicForm/Attachments/CommentAttachmentsForm';
import AttachmentMixin from '@/components/DynamicForm/Attachments/Mixins/AttachmentMixin';

import TinyMceEditor from '@/components/Editor/TinyMceEditor';
export default {
    mixins: [AttachmentMixin],
    components: {
       TinyMceEditor,
       CommentAttachmentsForm,      
    },
	props: {
		currentItem: {
		    type: Object,
		    required: true
		},
        userListItems: {
            type: Array,
            required: true,
            default: []
        },
        type: {
            type: String,
            required: false
        },
        caseId: {
            type: String,
            required: false
        },  
        atNewComment: {
            type: Array
        } 
    },
    filters: {
        htmlToPlaintext: function (text) {
            return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
        }
    },
    data() {
        return {  
            commentMentionList: [],
            updateCommentModel: null,
            uniqueCommentId : null,
            dialog: {
              'status': false,
              'content': "",
              'confirmText': "Ok!"
            },
            internal: false,
            atMentionsUserList: [],
            filteredItems: [],
            editAttachmentId: null,
            editAttachmentInternal: null,
            snackbarMsg: ''
        };
    },
    computed: {
        /**
         * Order comments and filter out internal comments for non-internal users
         * @returns {Array}
         */
    },
     watch: {
      'currentItem': {
        immediate: true,
        handler: function() { 
            this.getCommentData();
        },
      },
    },
    mounted() {
        if (this.$route.hash) {
            let id = this.$route.hash.replace("#", "");
            setTimeout(() => {
            this.scrollToElement(id);
            }, 1500);
        }
        this.getCommentData();
    },
    methods:{
        scrollToElement(id) {
            if (!id) {
                return
            }
            
            let parentEle = document.getElementById('sidePanelBody');
            const targetEle = document.getElementById(id);

            if (!parentEle || !targetEle) {
                return
            }

            if (targetEle) {
                // parentEle.scrollTo({
                //     top: this.getOffset(targetEle),
                //     left: 0,
                //     behavior: 'smooth'
                // });
                console.log('Scrolling to target element from CommentList.vue')
                targetEle.scrollIntoView(true)
            }
        },
        getOffset(targetEle) {
        if (!targetEle.getBoundingClientRect) {
            return 0;
        }
        const headerEle = document.querySelector('.md-toolbar');
        let offset = targetEle.getBoundingClientRect().top
        if (headerEle) {
            offset -= headerEle.getBoundingClientRect().height;
        }
        return offset;
        },

        deleteCommentAlert (item) {            
		
            Swal.fire({
                title: "Are you sure you want to delete comment ?",
                text: `The change cannot be undone.`,
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "md-button md-success btn-fill",
                cancelButtonClass: "md-button md-danger btn-fill",
                confirmButtonText: "Yes",
                buttonsStyling: false
            }).then(result => {
                if (result.value) {
                    this.deleteComment(item);
                }
            });
        },
        async deleteComment (item) {
            await API.graphql(graphqlOperation(mutations['deleteComment'], {input: {"id": item['id']}}))
                .then(this.afterDeleteComment(item))
                .catch(error => {
                this.$c.log(this.list.pageTitle + " delete record error:", error);
                });
        },
        afterDeleteComment (item) {
            this.isSnackbarOpen = true;
            this.snackbarMsg = 'Comment deleted successfully';
        },
        editComment (item) {
            this.uniqueCommentId = item.id;
            this.updateCommentModel = item.comment;
            this.internal = item.internal;

            // if attachments were updated then they will be in attachmentData -
            // then we will show updated attachments in dialog
            if (!this.attachmentData || !this.attachmentData.length) {
                // if attachments were not updated then show attachments in note
                if (item.attachment && item.attachment.length) {
                    this.attachmentData = item.attachment
                }
            }
        },
        clearComment () {
            this.updateCommentModel = null;
            this.uniqueCommentId = null;
            this.internal = false;
            //clean the array
            this.atMentionsUserList.splice(0, this.atMentionsUserList.length);
        },
        /**
         * placeholder() extracts attributes from comment body html,
         * searches @mention user's name and push it into userMentionArray
         */
        placeHolder () {
            let userMentionArray = [];
            //match attributes in html string
            let attributes = this.updateCommentModel.match(/[\w-]+="[^"]*"/g);

            if(attributes !== null) {
                attributes.forEach(el => {
                    if(el.startsWith('id=')) {
                        let replace1 = el.replace('id="', "");
                        let replace2 = replace1.replace('"', '');
                        //add extracted user name from attributes array in userMentionArray
                        userMentionArray.push(replace2);
                    }
                });
            }

            //if userMentionArray have data then form commentMentionList
            if(userMentionArray) {
                userMentionArray.forEach(ele => {
                    let obj = this.userListItems.find(o => o.name === ele);
                     if (obj) {
                         this.commentMentionList.push(obj);
                     }
                 });
            }
        },
        async updateComment (item) {
            this.placeHolder();
        	this.promisePending = true;
            let updateCommentData = {
                id: item.id,
                comment: this.updateCommentModel,
                internal: this.internal,
            }

            //get atMention user data
            this.getAtMentionUsers(updateCommentData);

            //update data for atMentions key
            if (this.atMentionsUserList && this.atMentionsUserList.length) {
                let atMentionsList = {
                    items: this.atMentionsUserList
                };
                updateCommentData.atMentions = JSON.stringify(atMentionsList);
            } else {
                updateCommentData.atMentions = JSON.stringify({});
            }

            /**
             * ATLAS-877 - Add Updatedby to all Models in the Schema
             * @see https://zeamster.atlassian.net/browse/ATLAS-877
             */
            updateCommentData['commentUpdatedById'] = this.$reduce(this, '$Session.userId');

            let gqlRequest = graphqlOperation(mutations['updateComment'], {input: updateCommentData});
            this.$c.log('gqlRequest', gqlRequest);

            const result = await API.graphql(gqlRequest)
            .then(async result => {
                this.$c.log(result);
                
                const newCommentId = result.data.updateComment.id
                const relations = [
                    { fromModelType: 'Comment', relationCommentId: newCommentId },
                ]
                if (this.caseId) {
                    relations.push({ fromModelType: 'Case', relationCaseId: this.caseId })
                }
                
                this.attachments = this.attachmentData
                await this.add(relations)
                this.clearComment()
                this.isBusy = false
                this.promisePending = false
            })
            .catch(error => {
                this.$c.log(error);
                this.dialog.status = true;
                this.dialog.content = error.errors[0].message;
                this.attachments = []
                this.promisePending = false;
            });
        },
        /**
         * ATLAS-378 Case Comment atMentions
         * Get atMention user data
         */
        getAtMentionUsers (commentData) {
            this.commentMentionList.forEach(el => {
                if(commentData.comment.includes(el.name)) {
                    if(this.atMentionsUserList.indexOf(el.id) == -1) {
                        this.atMentionsUserList.push(el.id);
                    }
                }
            });
        },
        timediff (updatedDateTimeStamp) {
            let updatedDate = new Date(updatedDateTimeStamp);
            let now = new Date(),
            secondsPast = (now.getTime() - updatedDate.getTime()) / 1000;
            let displayDate = updatedDate.toLocaleString('default', { month: 'long' }) + " " + updatedDate.getDate() + ", " + updatedDate.getFullYear() + ", " + updatedDate.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });          
            if(secondsPast < 60)
                return ' Just now ' + displayDate;
            if(secondsPast < 3600)
                return parseInt(secondsPast/60) + ' minutes ago ' + displayDate;
            if(secondsPast <= 86400)
                return parseInt(secondsPast/3600) + ' hour ago ' + displayDate;
            if(secondsPast > 86400)
                return displayDate;
        },
        async getCommentData() {
            const items = this.$reduce(this, 'currentItem.comments.items');
            if (!items || !items.length) {
                return [];
            }
            const newItems = [];
            for (const _comment of items) {
                let attachment = await this.getAttachment(_comment.id, "comment");
                const comment = JSON.parse(JSON.stringify(_comment));
                comment.attachment = attachment;
                newItems.push(comment);
            }

            const isInternalUser = this.$reduce(this, '$Session.isInternalGroupMember');
            const filteredItems = newItems.filter(_item => {
                return isInternalUser || !_item.internal;
            });
            this.filteredItems = _.orderBy(filteredItems, 'updatedAt', 'asc');

            if(this.atNewComment && this.atNewComment.length){
            setTimeout(() => {
                this.scrollToElement(this.atNewComment[0].commentId);
            }, 1500);
        }       
        },
        /**
         * Get attachment Types Enum
         * @returns {Array} array of objects holding enum options
         */
        async getAttachment(id, type) {
            var filterData = type == "note" ? { relationNoteId: { eq: id } } : { relationCommentId: { eq: id } }
            return new Promise((resolve, reject) => {
                let operation = graphqlOperation(queries_custom.searchCaseAttachments, { filter: filterData, limit: 999 });
                API.graphql(operation)
                .then(response => {
                    let values = this.$reduce(response, 'data.searchRelations.items');
                    let options = [];
                    const amplifyEnv = aws_exports.aws_content_delivery_bucket.match(/.*-(\w+)/)[1]
                    const s3Bucket = 'atlasemailattachments-' + amplifyEnv 
                    for (const _value of values) {
                        if (!_value.attachment) {
                            continue
                        }
                        if (_value.attachment.isDeleted === null || _value.attachment.isDeleted === undefined || _value.attachment.isDeleted === false) {
                            let url = `https://${s3Bucket}.s3.amazonaws.com/${_value.attachment.s3Path}`;
                            options.push({
                                id: _value.attachment.id,
                                commentId: id,
                                description: _value.attachment.description,
                                name: _value.attachment.name,
                                s3Path: url,
                                type: _value.attachment.type.replace(/_/ig, ' '),
                                internal: _value.attachment.internal
                            });
                        }
                    }
                    resolve(options.length > 0 ? options : null);
                })
                .catch(err => {
                    console.log('getAttachment - Error', err);
                    resolve(null);
                });
            });
        },
    }
}
</script>
<style lang="scss">    
  #picture{
    width: 40px;
    height: 40px;
    background-color: #999999;
    border: 4px solid #CCCCCC;
    border-top-color: rgb(80, 69, 69);
    border-top-style: solid;
    border-top-width: 4px;
    border-right-color: rgb(204, 204, 204);
    border-right-style: solid;
    border-right-width: 4px;
    border-bottom-color: rgb(204, 204, 204);
    border-bottom-style: solid;
    border-bottom-width: 4px;
    border-left-color: rgb(204, 204, 204);
    border-left-style: solid;
    border-left-width: 4px;
    border-image-source: initial;
    border-image-slice: initial;
    border-image-width: initial;
    border-image-outset: initial;
    border-image-repeat: initial;
    color: #FFFFFF;
    border-radius: 50%;
    border-top-left-radius: 50%;
    border-top-right-radius: 50%;
    border-bottom-right-radius: 50%;
    border-bottom-left-radius: 50%;
    margin: 5px auto;
    overflow: hidden;
    transition: all 0.2s;
    -webkit-transition: all 0.2s;
  }
  .edit, .delete{
    margin: 10px 10px 0 0;
    font-weight:400;
    color: #717d8f;
    cursor: pointer;
    display: inline;
  }
  .bold-500{
    font-weight:500;
  }
  .bold-400{
    font-weight:400;
  }
  .comment-box{
    border-bottom: 1px solid #e0dcdc;
    padding-top: 5px;
    padding-bottom: 5px;
    overflow-wrap: break-word;
    word-break: break-word;
  }
  .textarea-border{
      border: .5px solid #ded5d5;
  }
</style>
